<div *ngIf="packagingUnit != null">
  <app-packaging-navigation [itemId]="packagingUnit.id" [callerLevelId]="packagingPart.Unit"
    [callerTypeId]="packagingUnit.packagingTypeId" [currentDirectoryId]="currentDirectoryId"
    [brandName]="packagingUnit.brandName" [productName]="packagingUnit.productName"
    [articleNumber]="packagingUnit.articleNumber" [versionId]="packagingUnit.version"
    [isCurrentVersion]="packagingUnit.isCurrentVersion" [isPreview]="isPreview" [isGeneric]="isGeneric"
    [hasRecyclabilityResult]="packagingUnit.hasRecyclabilityResult"
    [hasLifeCycleResult]="packagingUnit.hasLifeCycleResult" [creationTimestamp]="packagingUnit.creationTimestamp">

    <div class="outer-container" *ngIf="packagingUnitForm && packagingUnit">

      <div *ngIf="isFormLocked">
        <alert type="info">
          <div class="icon-text-container">
            <mat-icon class="gray-icon-18">info</mat-icon>
            {{ 'packagingUnit.messages.packagingUnitLocked' | transloco }}
          </div>
        </alert>
      </div>

      <div *ngIf="isTracked && !isPreview">
        <alert type="info">
          <div class="icon-text-container">
            <mat-icon class="gray-icon-18">info</mat-icon>
            {{ 'packagingUnit.messages.packagingTracked' | transloco }}
          </div>
        </alert>
      </div>

      <div *ngIf="!isEditPermitted">
        <alert type="info">
          <div class="icon-text-container">
            <mat-icon class="gray-icon-18">info</mat-icon>
            {{ 'warnings.editNotPermitted' | transloco }}
          </div>
        </alert>
      </div>

      <form [formGroup]="packagingUnitForm">

        <div id="packaging-header">
          <div class="flex">
            <div id="type-id-date-container">
              <h1>{{ packagingUnitType?.name ?? 'packagingUnit.packagingUnit' | transloco }}</h1>
              <span *ngIf="packagingUnit.id != null; else elseHeader">
                <span class="grey">({{ 'commonPackagingFields.id' | transloco }}:
                  {{ packagingUnit.id }},
                  {{ 'commonPackagingFields.creationDate' | transloco }}:
                  {{ getLocaleDate(this.packagingUnit.creationTimestamp) }})
                </span>
              </span>
              <ng-template #elseHeader>
                <div class="grey">{{ 'packagingUnit.newPackagingUnit' | transloco }}</div>
              </ng-template>
            </div>
            <div class="flex-row flex-space-between version-tags-container">
              <div id="versions-container">
                <div (click)="loadHistoryVersions()" *ngIf="packagingUnit.id != null && !isPreview && !isUserValidator">
                  <mat-form-field class="form-field-versions">
                    <mat-label class="label-large">{{ 'home.packagingUnitHome.historyVersion' | transloco }}</mat-label>
                    <mat-select [(value)]="packagingUnit.version"
                      (selectionChange)="onHistoryVersionChange($event.value)">
                      <mat-select-trigger>
                        {{ 'common.text.version' | transloco }} {{ packagingUnit.version }}
                        <span *ngIf="packagingUnit.versionName">({{ packagingUnit.versionName }})</span>
                        {{ getDateTimeString(packagingUnit.lastModificationTimestamp) }}
                        <strong *ngIf="packagingUnit.isCurrentVersion">({{ 'common.text.current' | transloco
                          }})</strong>
                      </mat-select-trigger>
                      <mat-option *ngFor="let historyVersion of historyVersions" [value]="historyVersion.versionNumber">
                        {{ 'common.text.version' | transloco }} {{ historyVersion.versionNumber }} <span *ngIf="historyVersion.versionName">({{
                          historyVersion.versionName }})</span>
                        {{ getDateTimeString(historyVersion.creationTimestamp) }}
                        <strong *ngIf="historyVersion.isCurrentVersion">({{ 'common.text.current' | transloco
                          }})</strong>
                        <span class="spinner-container">
                          <mat-spinner diameter="24" color="accent" *ngIf="spinnerActive">
                          </mat-spinner>
                        </span>
                        <button mat-icon-button color="primary"
                          (click)="$event.stopPropagation(); editVersionName(historyVersion)">
                          <mat-icon class="version-edit-icon">edit</mat-icon>
                        </button>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="packaging-tag-container">
                <app-select-tags [allTags]="allTags" [selectedTags]="selectedTags"
                  *ngIf="!isPreview && !isUserValidator" (tagsChanged)="setTags()">
                </app-select-tags>
              </div>
            </div>
          </div>
          <div class="image-container"><img [src]="packagingUnitTypeImageSource"></div>
        </div>

        <app-relevant-calculation-selector [(relevantAnalysisTypes)]="relevantAnalysisTypes"/>

        <alert type="warning" *ngIf="changedPackagingPartsInfo.length > 0 && packagingUnit.isCurrentVersion">
          <p>{{ 'packagingUnit.messages.componentsChanged' | transloco }}</p>
          <div *ngFor="let component of changedPackagingPartsInfo" class="changed-component">
            <span>{{ 'common.dictionary.' + component.type | transloco }} </span>
            <span>{{ component.subtype }}, {{ 'common.text.id' | transloco }} {{ component.id }}</span>
            <span *ngIf="component.name"> ({{ component.name }})</span>
            <button mat-raised-button (click)="acceptComponentChange(component.id)" class="custom-button-side">
              {{ 'common.buttons.apply' | transloco }}
            </button>
            <button mat-raised-button (click)="declineComponentChange(component.id)" class="custom-button-side">
              {{ 'common.buttons.discard' | transloco }}
            </button>
          </div>
        </alert>

        <!--######################################################################################-->
        <!-- Primary packaging -->
        <!--######################################################################################-->

        <app-packaging-unit-html-template [formControl]="primaryPackagingControl"
          [fillingVolume]="fillingVolume" [showErrors]="submitted"
          [distributionCountries]="createUpdateHandler.distributionCountries"
          [fillingGoodTypes]="createUpdateHandler.fillingGoodTypes"
          [fillingGoodCategories]="createUpdateHandler.fillingGoodCategories"
          [fillingGoods]="createUpdateHandler.fillingGoods" [assemblyCountries]="createUpdateHandler.assemblyCountries"
          [canEditForm]="canEditForm" [isTracked]="isTracked" [packagingUnitTypeId]="packagingUnitType?.id"
          [(relevantAnalysisTypes)]="relevantAnalysisTypes">
        </app-packaging-unit-html-template>

        <div>
          <app-image-upload [canEditForm]="canEditForm" [images]="packagingUnit.images" (filesEdited)="onFilesEdited()">
          </app-image-upload>
        </div>

        <div>
          <app-certificate-upload [canEditForm]="canEditForm" [certificates]="packagingUnit.certificates" [certificateTypes]="allCertificateTypes" (filesEdited)="onFilesEdited()">
          </app-certificate-upload>
        </div>

        <div>
          <app-pdf-upload [canEditForm]="canEditForm" [pdfs]="packagingUnit.documents" (filesEdited)="onFilesEdited()">
          </app-pdf-upload>
        </div>

        <!--######################################################################################-->
        <!-- Additional packaging -->
        <!--######################################################################################-->

        <mat-expansion-panel [expanded]="true" class="additional-packaging-panel">
          <mat-expansion-panel-header collapsedHeight="100px" expandedHeight="100px">
            <mat-panel-title>
              <div class="panel-image-container"><img [src]="getComponentImage(componentTypes.MainBody,packagingUnitType?.id)"></div>
              <h2>{{ 'component.mainBody' | transloco }}</h2>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-additional-packaging-component #mainBody
            [componentEntries]="packagingUnitForm.controls.mainBodyControl.value" [showErrors]="submitted"
            [packagingUnit]="packagingUnit"
            [componentType]="componentTypes.MainBody" [handler]="createUpdateHandler.componentHandler"
            [packagingTypeId]="packagingUnitType?.id" [canEditForm]="canEditForm" [isTracked]="isTracked"
            [isSingleComponent]="true" [isPreview]="isPreview" [isUserValidator]="isUserValidator"
            [isDarkTheme]="isDarkTheme" (packagingTypeChanged)="setPackagingType($event)"
            (volumeChanged)="updateMainBodyVolume($event)"
            [displayComponentTypeImage]="false"
            [(relevantAnalysisTypes)]="relevantAnalysisTypes">
          </app-additional-packaging-component>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="false" class="additional-packaging-panel">
          <mat-expansion-panel-header collapsedHeight="100px" expandedHeight="100px">
            <mat-panel-title>
              <div class="panel-image-container"><img [src]="getComponentImage(componentTypes.Closure,packagingUnitType?.id)"></div>
              <h2>
                {{ 'component.closure' | transloco }}
                <span *ngIf="componentsCount[componentTypes.Closure]>0">
                  ({{ componentsCount[componentTypes.Closure] }})
                </span>
              </h2>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-additional-packaging-component #closure
            [componentEntries]="packagingUnitForm.controls.closuresControl.value" [showErrors]="submitted"
            [packagingUnit]="packagingUnit"
            [componentType]="componentTypes.Closure" [handler]="createUpdateHandler.componentHandler"
            [packagingTypeId]="packagingUnitType?.id" [canEditForm]="canEditForm" [isTracked]="isTracked"
            [isDarkTheme]="isDarkTheme" (componentCountChanged)="updateComponentCount($event)"
            [displayComponentTypeImage]="false"
            [(relevantAnalysisTypes)]="relevantAnalysisTypes">
          </app-additional-packaging-component>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="false" class="additional-packaging-panel">
          <mat-expansion-panel-header collapsedHeight="100px" expandedHeight="100px">
            <mat-panel-title>
              <div class="panel-image-container"><img [src]="getComponentImage(componentTypes.Decoration,packagingUnitType?.id)"></div>
              <h2>
                {{ 'component.decoration' | transloco }}
                <span *ngIf="componentsCount[componentTypes.Decoration]>0">
                  ({{ componentsCount[componentTypes.Decoration] }})
                </span>
              </h2>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-additional-packaging-component #decoration
            [componentEntries]="packagingUnitForm.controls.decorationsControl.value" [showErrors]="submitted"
            [packagingUnit]="packagingUnit"
            [componentType]="componentTypes.Decoration" [handler]="createUpdateHandler.componentHandler"
            [packagingTypeId]="packagingUnitType?.id" [canEditForm]="canEditForm" [isTracked]="isTracked"
            [isDarkTheme]="isDarkTheme" (componentCountChanged)="updateComponentCount($event)"
            [displayComponentTypeImage]="false"
            [(relevantAnalysisTypes)]="relevantAnalysisTypes">
          </app-additional-packaging-component>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="false" class="additional-packaging-panel">
          <mat-expansion-panel-header collapsedHeight="100px" expandedHeight="100px">
            <mat-panel-title>
              <div class="panel-image-container"><img [src]="getComponentImage(componentTypes.Inlay,packagingUnitType?.id)"></div>
              <h2>
                {{ 'component.inlay' | transloco }}
                <span *ngIf="componentsCount[componentTypes.Inlay]>0">
                  ({{ componentsCount[componentTypes.Inlay] }})
                </span>
              </h2>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-additional-packaging-component #inlay [componentEntries]="packagingUnitForm.controls.inlaysControl.value"
          [packagingUnit]="packagingUnit"
            [showErrors]="submitted" [componentType]="componentTypes.Inlay"
            [handler]="createUpdateHandler.componentHandler" [packagingTypeId]="packagingUnitType?.id"
            [canEditForm]="canEditForm" [isTracked]="isTracked" [isDarkTheme]="isDarkTheme"
            (componentCountChanged)="updateComponentCount($event)"
            [displayComponentTypeImage]="false"
            [(relevantAnalysisTypes)]="relevantAnalysisTypes">
          </app-additional-packaging-component>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="false" class="additional-packaging-panel">
          <mat-expansion-panel-header collapsedHeight="100px" expandedHeight="100px">
            <mat-panel-title>
              <div class="panel-image-container"><img [src]="getComponentImage(componentTypes.PackagingAid,packagingUnitType?.id)"></div>
              <h2>
                {{ 'component.packagingAid' | transloco }}
                <span *ngIf="componentsCount[componentTypes.PackagingAid]>0">
                  ({{ componentsCount[componentTypes.PackagingAid] }})
                </span>
              </h2>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-additional-packaging-component #packAid
            [componentEntries]="packagingUnitForm.controls.packagingAidsControl.value" [showErrors]="submitted"
            [packagingUnit]="packagingUnit"
            [componentType]="componentTypes.PackagingAid" [handler]="createUpdateHandler.componentHandler"
            [packagingTypeId]="packagingUnitType?.id" [canEditForm]="canEditForm" [isTracked]="isTracked"
            [isDarkTheme]="isDarkTheme" (componentCountChanged)="updateComponentCount($event)"
            [displayComponentTypeImage]="false"
            [(relevantAnalysisTypes)]="relevantAnalysisTypes">
          </app-additional-packaging-component>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="false" class="additional-packaging-panel">
          <mat-expansion-panel-header collapsedHeight="100px" expandedHeight="100px">
            <mat-panel-title>
              <h2>{{ 'packagingUnit.miscellaneous' | transloco }}</h2>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="grid-container">
            <div class="grid-item">
              <mat-card id="type-info">
                <mat-card-title class="grid-item-title">
                  {{ 'packagingUnit.fields.packagingLevelHeader' | transloco }}
                </mat-card-title>
                <mat-card-content class="inner-container">
                  <mat-form-field class="form-field-wide" floatLabel="always">
                    <mat-select matTooltip="{{ 'packagingUnit.fields.tooltips.packagingLevel' | transloco }}" [placeholder]="nullPlaceholder" formControlName="packagingLevel">
                      <mat-option *ngFor="let option of packagingLevelOptions" [value]="option.key">
                      {{ option.value }}
                    </mat-option>
                    </mat-select>
                    </mat-form-field >
                </mat-card-content>
              </mat-card>
            </div>

            <div class="grid-item">
              <mat-card id="type-info">
                <mat-card-title class="grid-item-title">
                  {{ 'packagingUnit.fields.isPackagingPartOfProductHeader' | transloco }}
                </mat-card-title>
                <mat-card-content class="inner-container">
                  <app-tri-state-selector formControlName="isPackagingPartOfProduct"
                    [options]="isPackagingPartOfProductDictionary"
                    label=""
                    matTooltip="{{ 'packagingUnit.fields.tooltips.isPackagingPartOfProduct' | transloco }}">
                  </app-tri-state-selector>
                </mat-card-content>
              </mat-card>
            </div>

            <div class="grid-item">
              <mat-card id="type-info">
                <mat-card-title class="grid-item-title">
                  {{ 'packagingUnit.fields.isMultiUsePackagingHeader' | transloco }}
                </mat-card-title>
                <mat-card-content class="inner-container">
                  <app-tri-state-selector formControlName="isMultiUsePackaging"
                    [options]="isMultiUseDictionary" label=""
                    matTooltip="{{ 'packagingUnit.fields.tooltips.isMultiUsePackaging' | transloco }}">
                  </app-tri-state-selector>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </mat-expansion-panel>

        <div *ngIf="!isPreview">
          <div id="version-name-container" *ngIf="canEditForm">
            <div id="version-name-label" class="label-large">
              {{ 'packagingUnit.messages.nameVersionLabel' | transloco }}
            </div>
            <div id="version-name-input">
              <mat-form-field class="form-field-medium">
                <mat-label class="label-large">{{ 'commonPackagingFields.versionName' | transloco }}</mat-label>
                <input formControlName="newVersionName" matInput autocomplete="off">
              </mat-form-field>
            </div>
          </div>

          <button mat-raised-button color="primary" (click)="onSubmit()" class="custom-button" [disabled]="!canEditForm"
            type="button">
            <mat-icon>save_alt</mat-icon>
            {{ 'common.buttons.save' | transloco }}
          </button>

          <button mat-raised-button color="primary" [matMenuTriggerFor]="analyses.analysesMenu"
            (click)="analyses.loadAnalysesForPackagingUnit()" [disabled]="packagingUnit.id == null || isUserValidator"
            *ngIf="!isGeneric" class="custom-button" type="button">
            <mat-icon svgIcon="analysis-icon"></mat-icon>
            {{'home.packagingUnitHome.evaluations' | transloco}}
          </button>
          <app-analyses-menu-packaging-units #analyses [packagingUnitId]="packagingUnit.id"
            [packagingUnitType]="packagingUnit.packagingTypeId" [versionId]="packagingUnit.version"
            [isUserValidator]="isUserValidator" [caller]="callerPageId"
            [hasRecyclabilityResult]="packagingUnit.hasRecyclabilityResult"
            [hasLifeCycleResult]="packagingUnit.hasLifeCycleResult"
            [creationTimestamp]="packagingUnit.creationTimestamp">
          </app-analyses-menu-packaging-units>

          <button mat-raised-button class="custom-button" [disabled]="packagingUnit.id == null || isUserValidator"
            [matMenuTriggerFor]="reports.reportsMenu" (click)="reports.loadReports()" type="button" color="primary">
            <mat-icon>topic</mat-icon>
            {{'report.buttons.buttonReports' | transloco}}
          </button>
          <app-reports-menu-for-packaging-part #reports [callerItemId]="packagingUnit.id" [callerPage]="callerPageId"
            [callerLevel]="callerLevelId">
          </app-reports-menu-for-packaging-part>
        </div>
      </form>
    </div>
  </app-packaging-navigation>
</div>
